module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "py-4 px-6 cursor-pointer rounded",
    on: {
      "mouseleave": function($event) {
        _vm.isObserverCardHover = false
      },
      "mouseover": function($event) {
        _vm.isObserverCardHover = true
      }
    }
  }, [_c('div', {
    class: {
      'with-bottom-border': _vm.show_assessment
    },
    attrs: {
      "id": ("submission-assessment-" + (_vm.submission.id))
    },
    on: {
      "click": _vm.toggleViewByPassAssessment
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full"
  }, [_c('div', {
    staticClass: "flex items-center"
  }, [_c('img', {
    staticClass: "w-8 h-8 rounded-full",
    attrs: {
      "src": _vm.submission.user.avatar_url
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openAnonymityModal.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ml-3 text-sm font-semibold",
    class: _vm.handleHoverObveserverCard
  }, [_vm._v("\n          " + _vm._s(_vm.submission.user.name) + "\n          "), (_vm.is_my_submission && _vm.getCurrentRT.hard_close === false) ? _c('button', {
    staticClass: "text-pinky ml-3 bg-white hover:underline rounded text-xs font-semibold",
    on: {
      "click": function($event) {
        return _vm.goToSubmitResponsePage()
      }
    }
  }, [_vm._v("\n            Write my response\n          ")]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "cursor-pointer text-xs text-gray-400"
  }, [_c('span', {
    staticClass: "font-medium text-gray-400 mr-1.5"
  }, [_vm._v("Joined discussion on:")]), _vm._v("\n        " + _vm._s(_vm.submission_by_pass_date) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "pl-11 mt-3 mb-2"
  }, [(_vm.is_allowed_to_view_assessment) ? _c('button', {
    staticClass: "flex items-center px-5 py-2 bg-gray-100 hover:text-white rounded cursor-pointer text-xs font-semibold hover:bg-blueGray-500",
    class: _vm.show_assessment && _vm.hasEvaluation(_vm.submission) ?
      'bg-blueGray-500 text-white' :
      'bg-gray-100 text-gray-400',
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleViewByPassAssessment.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Assessment\n        "), (_vm.hasEvaluation(_vm.submission)) ? _c('i', {
    staticClass: "fas fa-check ml-2 text-green-500"
  }) : _vm._e()]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-fd664268!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/byPassCard.vue
// module id = 1111
// module chunks = 61